import { api } from '@/core/api/';
import circleAlertTypes from '@/utils/constants/circleAlertTypes.js';

const circleArray = [
  circleAlertTypes.CircleOne,
  circleAlertTypes.CircleTwo,
  circleAlertTypes.CircleThree,
  circleAlertTypes.CircleFour,
];

export default {
  async fetchAlerts() {
    const { data: response } = await api.get('api/dashboard/alerts');
    if (response) {
      let index = 0;
      return response.map((item) => {
        if (index >= circleArray.length) index = 0;
        item.type = circleArray[index];
        index++;
        return item;
      });
    }
  },
  /**
   *
   * @param { alertTypeId, PageSize, PageIndex } filters
   */
  async fetchAlertsByType(filters) {
    const { data: response } = await api.get(
      `api/dashboard/alerts/${filters.alertTypeId}`,
      {
        params: {
          pageIndex: filters.pageIndex,
          pageSize: filters.pageSize,
        },
      }
    );
    if (response) {
      return response;
    }
  },
  fetchMessages() {
    return api.get('api/message/mesaggefordashboard');
  },
  fetchSchedule(date, applicationId) {
    return api.get('api/calendarEvent/dailyevents/', {
      params: {
        date: date,
        applicationId,
      },
    });
  },
  getEnrollmentCount() {
    return api.get('api/dashboard/enrollmentcount');
  },
  getEvents(params) {
    return api.get('api/dashboard/events', { params });
  },
  getWorkshops(params) {
    return api.get('api/dashboard/workshops', { params });
  },
  getNews(params) {
    return api.get('api/dashboard/news', { params });
  },
  getEducationalMaterials(params) {
    return api.get('api/dashboard/educationalmaterials', { params });
  },
  getEducationalMaterialCategories(params) {
    return api.get('api/dashboard/educationalmaterials/categories', {
      params,
    });
  },
  getAlerts(params) {
    return api.get('api/dashboard/alerts', { params });
  },
  getTeachingMaterial(params) {
    return api.get('api/dashboard/teachingmaterial', { params });
  },
  markMessages(payload) {
    return api.post(`api/dashboard/mark`, payload);
  },
  fetchUnreadMessages(params) {
    return api.get('api/dashboard/messagecount', { params });
  },
  saveReadMessage(messageId) {
    return api.post(`api/message/savemessageread/${messageId}`);
  },
  async downloadDocumentByAttachmentId(
    studentEvaluationsDocumentIds,
    studentEvaluationsAttachmentIds
  ) {
    let documentId = null;
    if (studentEvaluationsDocumentIds != '') {
      documentId = studentEvaluationsDocumentIds;
    }
    let attachmentId = null;
    if (studentEvaluationsAttachmentIds != '') {
      attachmentId = studentEvaluationsAttachmentIds;
    }
    return api
      .get(`/api/documents/getdocument/${documentId}/${attachmentId}/2`)
      .then((response) => {
        this.downloadDocument(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  downloadDocument(documentFile) {
    const byteChars = atob(documentFile.content);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    let blob = new Blob([byteArray], {
      type: documentFile.contentType,
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  getGraphics(params) {
    return api.get('api/dashboard/graphics', { params });
  },
  getGraphicByReportType(id) {
    return api.get(`api/dashboard/graphics/reportTypes/${id}`);
  },
  getSections(params) {
    return api.get(`api/dashboard/sections`, { params });
  },
};
